module.exports = __webpack_public_path__ + "img/20.e2439118.png";